import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import { LegacyFilterCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import {
  Condition,
  PlatformFilterCondition,
} from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import { formatRawDate } from "@app/util/formatters";
import { parseApiDateWithUtcTz } from "@app/util/parsers";
import { isCombinedPlatformCondition, isLegacyCombinedCondition } from "@app/util/viewModel/assert";
import { getRegularFieldConditionValue } from "@app/util/viewModel/convertFromPlatformFilterModel";
import {
  filterCombineOperatorToPlatformCombineOperator,
  getRegularFieldPlatformConditionValue,
} from "@app/util/viewModel/convertToPlatformFilterModel";

import DateField from "./DateField";

class ClosingDateField extends DateField {
  get isEssential() {
    return false;
  }

  convertToPlatformCondition(filterCondition: LegacyFilterCondition): PlatformFilterCondition {
    if (isLegacyCombinedCondition(filterCondition)) {
      const operator = filterCombineOperatorToPlatformCombineOperator[filterCondition.operator];
      return {
        [operator]: filterCondition.conditions.map((simpleCondition) => ({
          [this.platformFilterNames[0]]: getRegularFieldPlatformConditionValue(
            this,
            simpleCondition
          ),
        })),
      };
    } else {
      if (filterCondition.operator === FilterOperator.ON) {
        const date = formatRawDate(filterCondition.value, "yyyy-MM-dd");
        return {
          [this.platformFilterNames[0]]: { $dateOnly: true, $eq: date },
        };
      }

      return {
        [this.platformFilterNames[0]]: getRegularFieldPlatformConditionValue(this, filterCondition),
      };
    }
  }

  convertFromPlatformCondition(
    filterCondition: PlatformFilterCondition
  ): LegacyFilterCondition | undefined {
    if (isCombinedPlatformCondition(filterCondition)) {
      return super.convertFromPlatformCondition(filterCondition);
    } else {
      const platformFilterName = this.platformFilterNames.find((name) => name in filterCondition);

      if (platformFilterName) {
        const condition = filterCondition[platformFilterName] as Condition;
        if (PlatformFilterOperator.EQUALS in condition) {
          const value = condition[PlatformFilterOperator.EQUALS];
          if (value !== null) {
            return {
              operator: FilterOperator.ON,
              value: parseApiDateWithUtcTz(`${value as string}T00:00:00Z`).toISOString(),
            };
          }
        }
        return getRegularFieldConditionValue(this, filterCondition);
      }

      return getRegularFieldConditionValue(this, filterCondition);
    }
  }
}

export default ClosingDateField;
